import { render, staticRenderFns } from "./McImg.vue?vue&type=template&id=fce8bcbc&scoped=true&"
import script from "./McImg.vue?vue&type=script&lang=js&"
export * from "./McImg.vue?vue&type=script&lang=js&"
import style0 from "./McImg.vue?vue&type=style&index=0&id=fce8bcbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce8bcbc",
  null
  
)

export default component.exports